import { VARIANTS } from "@/components/home/HeroCopy";
import { HeroBackground } from "@/components/home/HeroBackground";

const NOTES = {
  A: "Module chips + small typing command on one row, under a thin divider.",
  B: "One short grey sentence + small command line underneath.",
  C: "Typing command moves above the heading (replaces the eyebrow), chips under the lead.",
};

const Cta = () => (
  <div className="mt-9 flex flex-wrap gap-3 font-mono text-[13px] uppercase tracking-[0.14em]">
    <span className="bg-[#BACD1C] px-7 py-4 text-black">Open free terminal</span>
    <span className="border border-white/20 px-7 py-4 text-[#ECEBE4]">Create free account</span>
  </div>
);

export default function HeroLab() {
  return (
    <div data-testid="hero-lab-page" className="min-h-screen bg-[#0A0A0A] px-2 py-6 sm:px-5">
      {Object.entries(VARIANTS).map(([k, V]) => (
        <section key={k} data-testid={`hero-variant-${k}`} className="relative mb-6 overflow-hidden rounded-2xl border border-white/[0.07] bg-[#08090B]">
          <div className="pointer-events-none absolute inset-0"><HeroBackground variant="both" intensity={0.32} /></div>
          <div className="relative mx-auto max-w-[1400px] px-5 py-14 md:px-12 md:py-20">
            <p className="mb-8 inline-block border border-[#FFB224]/40 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-[#FFB224]">Option {k} · {NOTES[k]}</p>
            <V />
            <Cta />
          </div>
        </section>
      ))}
    </div>
  );
}
